<!-- <template>
  <select v-select="{ props, emit, computedOptions }" class="tom-select">
    <slot></slot>
  </select>
</template>

<script>
import { defineComponent, computed, watch } from 'vue'
import { setValue, init, reInit } from './index'

export default defineComponent({
  directives: {
    select: {
      mounted(el, { value }) {
        // Clone the select element to prevent tom select remove the original element
        const clonedEl = cash(el)
          .clone()
          .insertAfter(el)[0]
        cash(el).attr('hidden', true)

        el.__tomSelectHtml = cash(el).html()

        // Initialize tom select
        setValue(clonedEl, value.props)
        init(clonedEl, value.emit, value.computedOptions)
      },
      updated(el, { value, oldValue }) {
        const clonedEl = cash(el).next()[0]
        const currentHtml = cash(el).html()

        const optionsChanged = (() => {
          try {
            return (
              JSON.stringify(oldValue?.props?.options) !== JSON.stringify(value.props.options) ||
              el.__tomSelectHtml !== currentHtml
            )
          } catch (e) {
            return true
          }
        })()

        el.__tomSelectHtml = currentHtml

        if (optionsChanged) {
          reInit(clonedEl, value.props, value.emit, value.computedOptions)
        } else {
          setValue(clonedEl, value.props)
        }
      }
    }
  },
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    modelValue: {
      type: [String, Number, Array],
      default: ''
    }
  },
  setup(props, context) {
    // Compute all default options
    const computedOptions = computed(() => {
      let options = {
        ...props.options,
        plugins: {
          dropdown_input: {},
          ...props.options.plugins
        }
      }

      if (Array.isArray(props.modelValue)) {
        options = {
          persist: false,
          create: true,
          onDelete: function(values) {
            return confirm(
              values.length > 1
                ? 'Are you sure you want to remove these ' +
                    values.length +
                    ' items?'
                : 'Are you sure you want to remove "' + values[0] + '"?'
            )
          },
          ...options,
          plugins: {
            remove_button: {
              title: 'Remove this item'
            },
            ...options.plugins
          }
        }
      }

      return options
    })

    // Watch value change
    watch(
      computed(() => props.modelValue),
      () => {
        context.emit('change')
      }
    )

    return {
      props,
      ...context,
      computedOptions
    }
  }
})
</script> -->
<template>
  <select v-select="{ props, emit, computedOptions }" class="tom-select">
    <slot></slot>
  </select>
</template>

<script>
import { defineComponent, computed, watch } from 'vue'
import { setValue, init, reInit } from './index'

export default defineComponent({
  directives: {
    select: {
      mounted(el, { value }) {
        // Clone the select element to prevent tom select remove the original element
        const clonedEl = cash(el)
          .clone()
          .insertAfter(el)[0]
        cash(el).attr('hidden', true)

        el.__tomSelectHtml = cash(el).html()
        el.__tomSelectValue = JSON.stringify(value?.props?.modelValue)

        // Initialize tom select
        init(clonedEl, value.emit, value.computedOptions)
        setValue(clonedEl, value.props)
      },


      updated(el, { value }) {
        const clonedEl = cash(el).next()[0]

        if (!clonedEl) return

        const currentHtml = cash(el).html()
        const currentValue = JSON.stringify(value?.props?.modelValue)
        const optionsChanged = el.__tomSelectHtml !== currentHtml
        const valueChanged = el.__tomSelectValue !== currentValue

        el.__tomSelectHtml = currentHtml
        el.__tomSelectValue = currentValue

        if (optionsChanged) {
          reInit(clonedEl, value.props, value.emit, value.computedOptions)
          return
        }

        if (valueChanged) {
          setValue(clonedEl, value.props)
        }
      }
      // updated(el, { value }) {
      //   // GET the already existing instance instead of running reInit
      //   const clonedEl = cash(el).next()[0]
        
      //   if (clonedEl && clonedEl.tomselect) {
      //     // Programmatically set the new values without breaking or closing the UI dropdown
      //     const tomselectInstance = clonedEl.tomselect;
          
      //     // Silently sync values if they differ, without triggering unnecessary rebuild loops
      //     const currentValues = Array.isArray(value.props.modelValue) 
      //       ? value.props.modelValue 
      //       : [value.props.modelValue];
            
      //     tomselectInstance.setValue(currentValues, true);
      //   }
      // }
    }
  },
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    modelValue: {
      type: [String, Number, Array],
      default: ''
    }
  },
  setup(props, context) {
    // Compute all default options
    const computedOptions = computed(() => {
      let options = {
        ...props.options,
        closeAfterSelect: false,
        plugins: {
          dropdown_input: {},
          ...props.options.plugins
        }
      }

      if (Array.isArray(props.modelValue)) {
        options = {
          persist: false,
          create: true,
          closeAfterSelect: false,
          onDelete: function(values) {
            return confirm(
              values.length > 1
                ? 'Are you sure you want to remove these ' +
                    values.length +
                    ' items?'
                : 'Are you sure you want to remove "' + values[0] + '"?'
            )
          },
          ...options,
          plugins: {
            remove_button: {
              title: 'Remove this item'
            },
            ...options.plugins
          }
        }
      }

      return options
    })

    // Watch value change
    watch(
      computed(() => props.modelValue),
      () => {
        context.emit('change')
      }
    )

    return {
      props,
      ...context,
      computedOptions
    }
  }
})
</script>
